// removed by extract-text-webpack-plugin
module.exports = {"root":"_1xPrW","emptyItem":"_2cVqz"};